import * as TinyPubSub from './TinyPubSub';

let blocked = false;

export const blockUserInteraction = (block, message) => {
  window.__hideShowInteractionBlocker && window.__hideShowInteractionBlocker(block, message);
  blocked = block;
  TinyPubSub.publish('UserInteractionBlockChange', blocked);
};

export const interactionsBlocked = () => blocked;
